/**
 * @file 保存通知
 * @author liudaoyu
 * {@link https://docs.google.com/document/d/1KJvE-27eDHJuWSjDINRLXlubG8qBZaio3oF1Ht5kX4Q/edit#}
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IOutput {
    notice_id: number;
}

export interface IInput {
    class_id: number; // int，班级编号
    content: string; // string，通知内容
    send_message: number; // int，是否发送通知 0: 不发送；1：发送
}

export const saveNotice = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.CLASS_SAVE_NOTICE, data).then((res: IResponse<IOutput>) => {
        return res.data as IOutput;
    });
};
